import { Request } from "@/utils";
import { TimeCardDetail } from "@/types";

class TimeCard extends Request {
    getTimeCardDetail(periodDetailCode?: string) {
        return this.get<TimeCardDetail>({
            url: '/mobile/attendance/month-info?periodDetailCode='+periodDetailCode,
        });
    }
}

export const TimeCardApi = new TimeCard();